class LocalizedPrice extends HTMLElement {
  static {
    const style = document.createElement("style");
    style.textContent =
      "localized-price:not([data-formatted]){visibility:hidden}";
    document.head.appendChild(style);
  }

  connectedCallback() {
    const amount = Number(this.dataset.amount);
    const { currency } = this.dataset;
    const locale = window.WYATT?.config?.locale ?? this.dataset.locale;
    const currencyDisplay = "showCurrency" in this.dataset ? "code" : "symbol";

    try {
      const formatted = new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        currencyDisplay,
      }).format(amount);

      this.textContent = formatted;
    } catch (e) {
      window.console.error(
        "localized-price: failed to format",
        { amount, currency, locale },
        e,
      );
    } finally {
      this.setAttribute("data-formatted", "");
    }
  }
}

customElements.define("localized-price", LocalizedPrice);
